(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lac-lightwrap-testimonials"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lac-lightwrap-testimonials'))customElements.define('lac-lightwrap-testimonials',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.abort=new AbortController();const options={signal:this.abort.signal};
const track=this.querySelector('.lac-lightwrap-testimonials-track'),cards=[...track.children],arrows=[...this.querySelectorAll('[data-direction]')],dialog=this.querySelector('dialog'),player=dialog.querySelector('video'),previews=[...this.querySelectorAll('.lac-lightwrap-testimonials-preview')];
if(!cards.length)return;
const index=()=>Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/(cards[0].offsetWidth+24))));
let active=-1;
const startAt=v=>Math.min(Number(v.dataset.start)||5,Math.max(0,(Number.isFinite(v.duration)?v.duration:6)-.1));
const sync=()=>previews.forEach((v,i)=>{
const showing=this.visible&&i===index()&&!dialog.open&&!document.hidden;
if(!showing){v.pause();return;}
if(!v.src){v.preload='auto';v.src=v.dataset.src;v.load();return;}
if(v.readyState<1||v.seeking)return;
if(!v.dataset.positioned){v.currentTime=startAt(v);return;}
v.muted=true;if(v.paused)v.play().catch(()=>{});
});
previews.forEach(v=>{
v.addEventListener('loadedmetadata',()=>{v.currentTime=startAt(v);},options);
v.addEventListener('seeked',()=>{if(v.currentTime>=startAt(v)-.05){v.dataset.positioned='true';v.classList.add('is-ready');sync();}},options);
v.addEventListener('ended',()=>{delete v.dataset.positioned;v.classList.remove('is-ready');v.currentTime=startAt(v);},options);
});
const update=()=>{const next=index();if(next!==active){active=next;const v=previews[next];v.pause();delete v.dataset.positioned;v.classList.remove("is-ready");if(v.readyState>=1)v.currentTime=startAt(v);}arrows[0].disabled=next<=0;arrows[1].disabled=next>=cards.length-1;sync();};
arrows.forEach(button=>button.addEventListener('click',()=>{const next=Math.max(0,Math.min(cards.length-1,index()+Number(button.dataset.direction)));track.scrollTo({left:next*(cards[0].offsetWidth+24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});},options));
track.addEventListener('scroll',()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;update();});},{passive:true,signal:this.abort.signal});
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.2;sync();},{threshold:.2});this.observer.observe(track);
this.onVisibility=sync;document.addEventListener('visibilitychange',sync,options);update();
this.querySelectorAll('.lac-lightwrap-testimonials-play').forEach(button=>button.addEventListener('click',()=>{this.trigger=button;previews.forEach(v=>v.pause());player.src=button.dataset.video;player.muted=false;player.currentTime=0;this.oldOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';player.play().catch(()=>{});},options));
dialog.querySelector('button').addEventListener('click',()=>dialog.close(),options);
dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}},options);
dialog.addEventListener('close',()=>{player.pause();player.removeAttribute('src');player.load();document.body.style.overflow=this.oldOverflow||'';this.trigger?.focus();sync();},options);
}
disconnectedCallback(){this.ready=false;this.abort?.abort();if(this.frame)cancelAnimationFrame(this.frame);this.frame=0;if(this.querySelector('dialog')?.open)document.body.style.overflow=this.oldOverflow||'';this.observer?.disconnect();document.removeEventListener('visibilitychange',this.onVisibility);this.querySelectorAll('video').forEach(v=>v.pause());}
});
  } catch(e) { console.error(e); }
})();

})();
